import { Component, inject, ViewEncapsulation } from '@angular/core';
import { CUSTOM_DATA } from '@vueling-ng/vy-ds/src/lib/components/globals/modal';

declare interface GenericModalData {
  label: string;
  styles: string;
}
@Component({
  selector: 'app-generic-modal',
  templateUrl: './generic-modal.component.html',
  styleUrl: './generic-modal.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class GenericModalComponent {
  private readonly _customData: GenericModalData = inject(CUSTOM_DATA) as GenericModalData;

  public readonly modalBody = this._customData.label;
  public readonly modalBodyClass = this._customData.styles;
}
